import { Injectable } from "@angular/core";

@Injectable()
export class BrowserUtils {
  static get isIosSafari() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    return iOS && webkit && !ua.match(/CriOS/i);
  }

  /**
   * Skip OIDC when this tab is prerender Chromium or a crawler nginx would
   * send to prerender. Matching only "Prerender" misses Googlebot if Chrome
   * forwards the inbound UA; those tabs must not signinRedirect to Identity.
   */
  static isPrerenderUserAgent(userAgent?: string): boolean {
    const ua =
      userAgent ??
      (typeof navigator !== "undefined" && navigator.userAgent ? navigator.userAgent : "");
    return /Prerender|Googlebot|bingbot|Google-InspectionTool|Chrome-Lighthouse|facebookexternalhit|LinkedInBot/i.test(
      ua,
    );
  }
}
